import { SVGIcon } from '@woolworthsnz/styleguide';
import { FacilityDTO } from '../DTOs';

const mapServiceIcon = (service: string): SVGIcon => {
	switch (service.toLowerCase()) {
		case 'atm':
			return SVGIcon.Atm;
		case 'rug doctor':
			return SVGIcon.RugDoctor;
		case 'lotto':
			return SVGIcon.Lotto;
		case 'fresh flowers':
			return SVGIcon.FreshFlowers;
		case 'soft plastic recycling':
			return SVGIcon.PlasticRecycling;
		case 'ev charging':
			return SVGIcon.EvCharging;
		case 'scan and go':
			return SVGIcon.ScanAndGo;
		case 'gold card':
			return SVGIcon.GoldCard;
		case 'supergold card':
			return SVGIcon.GoldCard;
		default:
			return SVGIcon.DefaultService;
	}
};

export const getServices = (facilities: string[]): FacilityDTO[] => {
	const facilityDTOs: FacilityDTO[] = [];

	facilities.forEach((service) => {
		const serviceIcon = mapServiceIcon(service);
		if (serviceIcon !== SVGIcon.DefaultService) {
			facilityDTOs.push({
				name: service,
				icon: serviceIcon,
			});
		}
	});

	return facilityDTOs;
};
